export function fuzzyMatch(pattern, str) {
  pattern = '.*' + pattern.toLowerCase().split('').join('.*') + '.*';
  const re = new RegExp(pattern);
  return re.test(str.toLowerCase());
}
